import * as Container from "@repo/ui/container";
import { getDeliveryAndReturnsData, GetDeliveryAndReturnsProps } from "./api";
import { DeliveryAndReturnsContent } from "./content";
import classes from "./index.module.css";

export const DeliveryAndReturnsView = async ({
  requestInstance,
  countryData,
}: GetDeliveryAndReturnsProps) => {
  const deliveryAndReturnsData = await getDeliveryAndReturnsData({
    requestInstance,
    countryData,
  });

  if (!deliveryAndReturnsData) {
    //todo: what should we do here? is this unecessary cos errors will be caught?
    return null;
  }

  return (
    <>
      <div className={classes.bar}>
        <Container.Root size="medium" asChild>
          <h1 className={classes.subTitle}>Delivery & Returns</h1>
        </Container.Root>
      </div>
      <Container.Root size="medium" asChild>
        <DeliveryAndReturnsContent
          className={classes.viewContent}
          deliveryAndReturnsData={deliveryAndReturnsData}
          lang={countryData.defaultLanguage}
        />
      </Container.Root>
    </>
  );
};
